import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function CustomNodes() {

    return (
        <div>
            <DHeader>Custom Nodes</DHeader>
       
            <DText>
              Given the number of python modules that exist today, any one can be plugged into a Laeyerz Flow.
              This is done by creating a custom node.
              Custom nodes can also be used for any task including complex actions that are not available in the prebuilt nodes.
            </DText>



            <DText>
                Agents build are also custom nodes to allow users to integrate agents into their workflows.
            </DText>

          
            
            {/* <DCode>
                {`python QuickStart.py`}
            </DCode> */}
       
        </div>
    )
}